import {connect} from 'react-redux';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {compose} from 'redux';
import AppButton from '../../../components/app-button';
import Header1 from '../../../components/headers/header1';
import {Column, Row} from '../../../components/layout';
import {
  addToGlobalStyles,
  setGlobalStyles,
  setIbanFilterOpenTrigger,
  setDisableReimbursementRequestButton,
  setWizard,
  setIban,
  setTitular,
  setUserBankAccountDataWasUpdated,
} from '../../../store/actions';
import colors, {pageBackgrounds} from '../../../util/colors';
import * as fonts from '../../../util/fonts';

import './styles.scss';
import Icon from '../../../components/icon';
import {Icons} from '../../../util/icons';
import ReimbursementsList from './components/ReimbursementsList';
import {get} from '../../../api/api';
import {
  getPartialRefusalReasons,
  uriIreneCoverages,
  uriMemberData,
  uriRefundDetails,
  uriRefunds,
  uriStatuses,
  uriRefundPaymentDetails,
} from '../../../api/endpoints';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import {Expense} from '../../../components/expenses-detail/ExpensesDetail';
import ReimbursementsDetail from './components/ReimbursementsDetail';
import ClaimItemsFilter, {
  ClaimItemsFilterProps,
} from '../components/ClaimItemsFilter';
import {
  createCoveragesMap,
  createGUID,
  sortArrayByParam,
} from '../../../util/utility';
import ClaimsFilterModal from '../components/ClaimsFilterModal';
import {ReimbursementItem} from './interfaces';
import AppSpinner from '../../../components/app-spinner';
interface ReimbursementHistoryProps {
  user: any;
  addToGlobalStyles(value: any): void;
  setGlobalStyles(value: any): void;
  setIbanFilterOpenTrigger(value: any): void;
  setDisableReimbursementRequestButton(value: any): void;
  selectedBu: any;
  labels: typeof strings.pt.refund;
  stringsIban: typeof strings.pt.ibanRefunds;
  createRefundLabels: typeof strings.pt.createRefund;
  setWizard(values: any): void;
  availableBus: any[];
  buStyles: any;
  iban: any;
  busFuncMap: any;
  titular: any;
  bankAccountDataHolder: any;
  userBankAccountDataWasUpdated: boolean;
  setUserBankAccountDataWasUpdated: Function;
  setIban: Function;
  setTitular: Function;
}

export interface ReimbursementItemList {
  items: ReimbursementItem[];
}

export interface ReimbursementApiResponse {
  data: ReimbursementItemList;
  total: number;
  StatusCode: number;
}

function ReimbursementHistory({
  user,
  addToGlobalStyles,
  setGlobalStyles,
  setIbanFilterOpenTrigger,
  setDisableReimbursementRequestButton,
  selectedBu,
  labels,
  setWizard,
  availableBus,
  buStyles,
  iban,
  busFuncMap,
  titular,
  bankAccountDataHolder,
  stringsIban,
  createRefundLabels,
  userBankAccountDataWasUpdated,
  setUserBankAccountDataWasUpdated,
  setIban,
  setTitular,
}: ReimbursementHistoryProps) {
  const [selectedItem, setSelectedItem] = useState<{
    auditNbr?: string;
    catCode?: string;
    catName?: string;
    stateId?: string;
    state?: string;
    lastUpdate?: string;
    providerName?: string;
    clinicName?: string;
    rede?: string;
    isCat9?: number;
    dosFrom?: string;
    dosThru?: string;
    submittedBy?: string;
    amountPaid?: number;
    sessionId?: string;
    processNbr?: string;
    checkDate?: string;
  }>({});
  const [showModal, setShowModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const completedSessionIds = useRef<Set<any>>(new Set());
  const [refunds, setrefunds] = useState<ReimbursementApiResponse>();
  const [refundDetails, setrefundDetails] = useState<any[]>([]);
  const [statuses, setstatuses] = useState<any[]>([]);
  const [coverages, setcoverages] = useState<any[]>([]);
  const [updateFlag, setUpdateFlag] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingPaymentDetail, setLoadingPaymentDetail] = useState(false);
  const [errorLoadingDetail, setErrorLoadingDetail] = useState(false);
  const [currency, setCurrency] = useState<string>();
  const [ibanDetails, setIbanDetails] = useState('');
  const [filter, setFilter] = useState<ClaimItemsFilterProps>({
    controlLabels: {
      filterParmOne: labels?.filterCoverageLabel,
      filterParmTwo: labels?.filterStatusLabel,
      filterDateFrom: labels?.filterDateLabel,
    },
    filterOneOptions: [],
    filterTwoOptions: [],
    filterParmOne: '',
    filterParmTwo: '',
    periodFrom: moment().subtract(6, 'month').toDate(),
    periodTill: moment().toDate(),
    filterParameterChanged: () => {},
    filtersHaveChanged: false,
  });

  const history = useHistory();
  const featureName = 'ReimbursementList';

  // --- Derived / computed values ---

  const createRefundActive = useMemo(
    () =>
      busFuncMap[selectedBu.buId]?.find(
        (func: any) =>
          func.featureTemplateAlias === functionalitiesAliasMap.createRefund,
      ),
    [busFuncMap, selectedBu.buId],
  );

  const ibanFuncActive = useMemo(
    () =>
      busFuncMap[selectedBu.buId]?.find(
        (func: any) =>
          func?.featureTemplateAlias === functionalitiesAliasMap.iban,
      )?.isVisible,
    [busFuncMap, selectedBu.buId],
  );

  const isTitularLogged = useMemo(
    () =>
      bankAccountDataHolder === 'SUBSCRIBER'
        ? titular?.memId === selectedBu?.memId &&
          titular?.buId === selectedBu?.buId &&
          titular?.nif === selectedBu?.nif
        : true,
    [bankAccountDataHolder, titular, selectedBu],
  );

  console.log({
    titular: titular,
    selectedBu: selectedBu,
    user: user,
  });

  const color = useMemo(
    () =>
      statuses.find((e) => e.value === selectedItem.stateId?.toLowerCase())
        ?.colorCode,
    [statuses, selectedItem.stateId],
  );

  const canCreateReimbursment = useMemo(() => {
    if (!createRefundActive?.isVisible) return false;
    if (!ibanFuncActive) return true;
    if (stringsIban?.ibanRefunds_ibanIsEnabled === '1') return !!titular?.iban;
    return true;
  }, [
    createRefundActive,
    ibanFuncActive,
    stringsIban?.ibanRefunds_ibanIsEnabled,
    titular?.iban,
  ]);

  const disableCreateRefundButton = useMemo(() => {
    if (stringsIban?.ibanRefunds_ibanIsEnabled !== '1') return false;
    if (stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds !== '1')
      return false;
    return !titular?.iban || !ibanFuncActive;
  }, [
    stringsIban?.ibanRefunds_ibanIsEnabled,
    stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds,
    titular?.iban,
    ibanFuncActive,
  ]);

  const canCreateWithMessage = useMemo(
    () =>
      stringsIban?.ibanRefunds_ibanIsEnabled !== '1' &&
      stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds === '1',
    [
      stringsIban?.ibanRefunds_ibanIsEnabled,
      stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds,
    ],
  );

  // --- Callbacks ---

  const handleDefineIban = useCallback(() => {
    setIbanFilterOpenTrigger({ibanFilter: true});
    history.push({pathname: '/perfil', state: {openIban: true}});
  }, [setIbanFilterOpenTrigger, history]);

  const msgBelowCreateRefundButton = useMemo(() => {
    if (!ibanFuncActive) return null;
    if (stringsIban?.ibanRefunds_ibanIsEnabled === '1') {
      switch (stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds) {
        case '0': {
          return isTitularLogged ? (
            <>
              {createRefundLabels?.refund_alert_owner_1}
              <a
                className="define-iban-anchor-label"
                style={{
                  ...fonts.SM,
                  color: buStyles?.primaryColor || colors.blue,
                  textDecoration: 'underline',
                }}
                onClick={handleDefineIban}>
                {createRefundLabels?.refund_alert_owner_2}
              </a>
            </>
          ) : (
            <span key={selectedBu.famId}>
              {createRefundLabels?.refund_alert_not_owner}
            </span>
          );
        }
        case '1': {
          if (bankAccountDataHolder === 'SUBSCRIBER') {
            if (titular?.iban) return null;
            return isTitularLogged ? (
              <Row className="fill-iban-here">
                <p>
                  {stringsIban?.ibanRefunds_fillIbanMyData}{' '}
                  <a
                    className="define-iban-anchor-label"
                    style={{
                      color: buStyles?.primaryColor || colors.blue,
                      textDecoration: 'underline',
                      marginLeft: '3px',
                    }}
                    onClick={() =>
                      history.push({
                        pathname: '/perfil',
                        state: {patientSelected: selectedBu, openIban: true},
                      })
                    }>
                    {stringsIban?.ibanRefunds_fillIbanMyDataLink}
                  </a>
                </p>
              </Row>
            ) : (
              <span key={selectedBu.famId} className="semibold">
                {stringsIban?.ibanRefunds_fillIbanAskTitular}
              </span>
            );
          }
          if (bankAccountDataHolder === 'INDIVIDUAL') {
            return (
              !titular?.iban && (
                <Row className="fill-iban-here">
                  <p>
                    {stringsIban?.ibanRefunds_fillIbanMyData}{' '}
                    <a
                      className="define-iban-anchor-label"
                      style={{
                        color: buStyles?.primaryColor || colors.blue,
                        textDecoration: 'underline',
                        marginLeft: '3px',
                      }}
                      onClick={() =>
                        history.push({
                          pathname: '/perfil',
                          state: {patientSelected: selectedBu, openIban: true},
                        })
                      }>
                      {stringsIban?.ibanRefunds_fillIbanMyDataLink}
                    </a>
                  </p>
                </Row>
              )
            );
          }
          break;
        }
      }
    } else {
      if (isTitularLogged) {
        return (
          !titular?.iban && (
            <p className="semibold">
              {stringsIban?.ibanRefunds_fillIbanAskInsuranceCompany}
            </p>
          )
        );
      } else {
        return (
          !titular?.iban && (
            <p className="semibold">
              {canCreateWithMessage
                ? stringsIban?.ibanRefunds_fillIbanAskInsuranceCompanyNotOwner
                : stringsIban?.ibanRefunds_fillIbanAskTitular}
            </p>
          )
        );
      }
    }
    return null;
  }, [
    ibanFuncActive,
    stringsIban,
    isTitularLogged,
    createRefundLabels,
    buStyles,
    bankAccountDataHolder,
    titular?.iban,
    selectedBu,
    history,
    handleDefineIban,
    canCreateWithMessage,
  ]);

  const triggerRefresh = useCallback(() => {
    setUpdateFlag((f) => !f);
  }, []);

  const changedItem = useCallback(
    (filterItem: ReimbursementItem) => {
      if (filterItem.stateId === '101') {
        get(
          uriRefundDetails(
            selectedBu.buId,
            filterItem.auditNbr,
            filterItem.processNbr,
            filterItem.sessionId,
            filterItem.isCat9,
            filterItem.catCode,
          ),
          false,
          0,
          featureName,
        ).then((res: any) => {
          const metadata = res.data.refundsOcr.metadata;
          const patients = Object.keys(availableBus).map((key: any) => {
            const bu = availableBus[key];
            return {...bu, id: createGUID()};
          });
          const selectedPatient =
            patients.find(
              (patient) => !!patient.nif && patient.nif === metadata.nif,
            ) || patients[0];
          const patientValidation = {patients, ...selectedPatient};
          const files = metadata.documents.map((document: any) => {
            const aux = (document.fileName as string)?.split('/');
            return {
              path: (aux && aux[aux.length - 1]) || document.fileName,
              preview: document.fileName,
              id: createGUID(),
              name: 'Fatura',
            };
          });
          setWizard({
            step: 2,
            patientValidation,
            attachFiles: {sessionId: filterItem.sessionId, files},
            invoiceValidation: metadata,
          });
          history.push('/historico-reembolsos/pedido-reembolso', {
            downloadBlobs: true,
          });
        });
      } else {
        setSelectedItem(filterItem);
        setShowModal(true);
      }
    },
    [selectedBu.buId, availableBus, setWizard, history],
  );

  const filterParameterChanged = useCallback(
    (filterParameter: string, ParameterValue: string | Date) => {
      setFilter((prev) => ({...prev, [filterParameter]: ParameterValue}));
      triggerRefresh();
    },
    [triggerRefresh],
  );

  const modalWasClosed = useCallback(() => {
    if (filter.filtersHaveChanged) {
      triggerRefresh();
    }
  }, [filter.filtersHaveChanged, triggerRefresh]);

  const getRefundPaymentDetails = useCallback(
    async (checkNbr: any) => {
      try {
        setLoadingPaymentDetail(true);
        const resultToFormat: any = await get(
          uriRefundPaymentDetails(selectedBu.buId, checkNbr),
          false,
          0,
          featureName,
        );
        setIbanDetails(resultToFormat?.data?.nib ?? '');
      } catch {
        setIbanDetails('');
      } finally {
        setLoadingPaymentDetail(false);
      }
    },
    [selectedBu.buId],
  );

  const getTheRefunds = useCallback(async () => {
    if (!selectedBu) return;
    setIsLoading(true);
    const filterFromDate = filter.periodFrom
      ? moment(filter.periodFrom).format('YYYY-MM-DD')
      : '1900-01-01';
    const filterToDate = filter.periodTill
      ? moment(filter.periodTill).format('YYYY-MM-DD')
      : '2030-12-31';
    try {
      const res: any = await get(
        uriRefunds(
          selectedBu.buId,
          selectedBu.memId,
          0,
          filterFromDate,
          filterToDate,
          10000,
          filter.filterParmOne,
          filter.filterParmTwo,
        ),
        false,
        0,
        featureName,
      );
      setrefunds(res as ReimbursementApiResponse);
      setCurrency(res?.data?.items?.[0]?.currency);
    } catch (err) {
      console.error(err);
      setrefunds({} as ReimbursementApiResponse);
      setCurrency(createRefundLabels.default_currency);
    } finally {
      setIsLoading(false);
    }
  }, [selectedBu, filter, createRefundLabels.default_currency]);

  const onClickReimbursementRequest = useCallback(() => {
    setWizard({currency});
    history.push('/historico-reembolsos/pedido-reembolso');
  }, [setWizard, currency, history]);

  const ItemFinishedSubmitting = useCallback(
    (sessionId: any) => {
      if (!completedSessionIds.current.has(sessionId)) {
        completedSessionIds.current.add(sessionId);
        getTheRefunds();
      }
    },
    [getTheRefunds],
  );

  // --- Effects ---

  // Set page background once on mount
  useEffect(() => {
    addToGlobalStyles({background: pageBackgrounds.reimbursementPage});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refresh member data when bank account was updated externally
  useEffect(() => {
    if (!selectedBu?.memId || !userBankAccountDataWasUpdated) return;
    const getMemberData = async () => {
      const memberData: any = await get(
        uriMemberData(selectedBu?.buId, selectedBu?.memId, selectedBu?.famId),
        false,
        0,
        featureName,
      );
      if (bankAccountDataHolder === 'INDIVIDUAL') {
        setIban(memberData?.data?.iban);
        setTitular(memberData?.data);
      }
      setUserBankAccountDataWasUpdated(false);
    };
    getMemberData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userBankAccountDataWasUpdated]);

  // Load statuses and coverages on mount, then trigger initial refunds fetch
  useEffect(() => {
    let cancelled = false;

    const loadFiltersData = async () => {
      const [statusRes, coverageRes]: any[] = await Promise.all([
        get(uriStatuses(), false, 0, featureName),
        selectedBu
          ? get(
              uriIreneCoverages(selectedBu.buId, selectedBu.benNbr),
              false,
              0,
              featureName,
            )
          : Promise.resolve(null),
      ]);
      if (cancelled) return;

      const statusOptions = sortArrayByParam(
        (statusRes.data?.items as any[])
          .filter((e) => e.stateName !== 'Default')
          .map((e) => ({
            value: e.stateId,
            label: e.stateName,
            colorCode: e.color,
            stateId: e.stateId,
          })),
        'label',
      );
      setstatuses(statusOptions);

      const coveragesMap = createCoveragesMap(coverageRes?.data?.items);
      const coverageOptions = sortArrayByParam(
        Object.values(coveragesMap).map((e: any) => ({
          value: e.catCode,
          label: e.catCodeDesc,
        })),
        'label',
      );
      setcoverages(coverageOptions);

      setFilter((prev) => ({
        ...prev,
        filterTwoOptions: statusOptions,
        filterOneOptions: coverageOptions,
      }));
    };

    loadFiltersData();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch refunds when the selected member or updateFlag changes
  useEffect(() => {
    getTheRefunds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBu.memId, updateFlag]);

  // Load refund detail lines when the modal opens; clear on close
  useEffect(() => {
    setErrorLoadingDetail(false);
    if (!showModal) {
      setrefundDetails([]);
      return;
    }
    setIsLoading(true);
    setLoadingDetail(true);
    get(
      uriRefundDetails(
        selectedBu.buId,
        selectedItem.auditNbr,
        selectedItem.processNbr,
        selectedItem.sessionId,
        selectedItem.isCat9,
        selectedItem.catCode,
      ),
      false,
      0,
      featureName,
    )
      .then((result: any) => {
        const res = result.data;
        const aux: Expense[] = res.refunds;
        res.refunds.forEach((ref: any) => {
          if (ref.amountDisallow > 0) {
            get(
              getPartialRefusalReasons(selectedBu.buId, ref?.code),
              false,
              0,
              featureName,
            ).then((partialRefusalReason: any) => {
              if (partialRefusalReason?.data?.items?.length > 0) {
                const index = res.refunds.indexOf(ref);
                aux[index]['partialRefusalReason'] =
                  partialRefusalReason?.data?.items;
              }
            });
          }
          setrefundDetails(aux);
        });
        if (
          aux[0]?.checkNbr &&
          selectedItem.stateId === '6' &&
          selectedItem.amountPaid! >= 0.01
        ) {
          getRefundPaymentDetails(aux[0]?.checkNbr);
        }
      })
      .catch(() => setErrorLoadingDetail(true))
      .finally(() => {
        setIsLoading(false);
        setLoadingDetail(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  // Sync disabled state to Redux store
  useEffect(() => {
    setDisableReimbursementRequestButton(disableCreateRefundButton);
  }, [disableCreateRefundButton, setDisableReimbursementRequestButton]);

  return (
    <>
      <Column className="reimbursement-history-container ">
        <Row className="reimbursement-history-titlerow reimbursement-history-row">
          <Column className="reimbursement-history-titlecolumn">
            <Header1
              className="reimbursement-history-heading1"
              style={{...fonts.XL, ...fonts.Bold}}>
              {labels?.refundHistory_title}
            </Header1>
            <label
              className="reimbursement-history-subtitle"
              style={{...fonts.M}}>
              {labels?.refundHistory_verifyRequest}
            </label>
          </Column>
          <Column className="reimbursement-history-requestcolumn">
            {createRefundActive?.isVisible && (
              <AppButton
                disabled={disableCreateRefundButton}
                onClick={onClickReimbursementRequest}
                className="homepage-request-reimbursement-button reimbursement-history-request-button">
                {labels?.refundHistory_addRefund}
              </AppButton>
            )}
            {((!canCreateReimbursment && createRefundActive?.isVisible) ||
              (disableCreateRefundButton && createRefundActive?.isVisible) ||
              canCreateWithMessage) && (
              <div
                className="create-refund-alert"
                style={{...fonts.SM, ...fonts.SemiBold}}>
                {msgBelowCreateRefundButton}
              </div>
            )}
          </Column>
        </Row>
        <Row className="reimbursement-history-row reimbursement-history-row-filter">
          <ClaimItemsFilter
            restrictDateInterval={true}
            filterParmOne={filter.filterParmOne}
            filterParmTwo={filter.filterParmTwo}
            periodFrom={filter.periodFrom}
            periodTill={filter.periodTill}
            filterParameterChanged={filterParameterChanged}
            filterTwoOptions={statuses}
            filterOneOptions={coverages}
            controlLabels={{
              filterParmOne: labels?.filterCoverageLabel,
              filterParmTwo: labels?.filterStatusLabel,
              filterDateFrom: labels?.filterDateLabel,
            }}
            filtersHaveChanged={false}></ClaimItemsFilter>
        </Row>
        {isLoading ? (
          <AppSpinner className="loading-outlined" />
        ) : (
          <Row className="reimbursement-history-row reimbursement-history-declarationslist-row">
            <Column className="reimbursement-history-declarationslist-column">
              <Row className="reimbursement-history-declarationslist-sub-row">
                <Column className="reimbursement-history-filterbuttoncolumn">
                  <AppButton
                    className="reimbursement-history-filterbutton"
                    onClick={() => setShowFilterModal(true)}>
                    <Row className="reimbursement-history-filter-row">
                      <Icon
                        className="reimbursement-history-filter-icon"
                        name={Icons.FILTER}
                        color={colors.white}
                        width="16"
                        height="16"
                        changeViewbox={false}
                        viewBox={'0 -5 26 30'}
                      />
                      {labels?.refundHistory_filterButton}
                    </Row>
                  </AppButton>
                </Column>
                {/** To remove display: 'none' when this feature is available */}
                <Column className="reimbursement-history-declarationsbuttoncolumn">
                  <AppButton
                    className="reimbursement-history-declarationsbutton"
                    variant="secondary">
                    <Row className="reimbursement-history-declarationsrow">
                      <Icon
                        className="reimbursement-history-declarationsicon"
                        name={Icons.DECLARATIONS}
                        color={buStyles?.primaryColor || colors.blue}
                        width="16"
                        height="16"
                        changeViewbox={false}
                      />
                      {labels?.refundHistory_declarations}
                    </Row>
                  </AppButton>
                </Column>
              </Row>

              <ReimbursementsList
                reimbursementItems={
                  refunds?.data?.items?.length ? refunds.data.items : []
                }
                statuses={statuses}
                changedItem={changedItem}
                ReimbursementFinishedSubmitting={ItemFinishedSubmitting}
              />
            </Column>
          </Row>
        )}
      </Column>
      <div className="expense-detail-modal">
        <ReimbursementsDetail
          color={color}
          expenses={refundDetails}
          setShowModal={setShowModal}
          showModal={showModal}
          ReimbursementFinishedSubmitting={ItemFinishedSubmitting}
          selectedItem={selectedItem}
          setUpdateFlag={triggerRefresh}
          updateFlag={updateFlag}
          changedItem={changedItem}
          checkdate={selectedItem.checkDate || ''}
          statuses={statuses}
          loadingDetail={loadingDetail || loadingPaymentDetail}
          isLoading={isLoading}
          errorLoading={errorLoadingDetail}
          loadingPaymentDetail={loadingPaymentDetail}
          ibanDetails={ibanDetails}
        />
      </div>
      <ClaimsFilterModal
        setShowFilterModal={setShowFilterModal}
        showFilterModal={showFilterModal}
        filterProps={filter}
        setFilter={setFilter}
        modalWasClosed={modalWasClosed}
      />
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  strings,
  user,
  availableBus,
  globalStyles,
  iban,
  busFuncMap,
  titular,
  bankAccountDataHolder,
  userBankAccountDataWasUpdated,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.refund,
  createRefundLabels: strings.value.pt.createRefund,
  stringsIban: strings.value.pt.ibanRefunds,
  availableBus: availableBus.value,
  buStyles: globalStyles.value,
  iban: iban.value,
  busFuncMap: busFuncMap.value,
  titular: titular.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
  userBankAccountDataWasUpdated: userBankAccountDataWasUpdated.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
  setIbanFilterOpenTrigger: (value: any) =>
    dispatch(setIbanFilterOpenTrigger(value)),
  setDisableReimbursementRequestButton: (value: any) =>
    dispatch(setDisableReimbursementRequestButton(value)),
  setIban: (value: any) => dispatch(setIban(value)),
  setTitular: (value: any) => dispatch(setTitular(value)),
  setUserBankAccountDataWasUpdated: (value: any) =>
    dispatch(setUserBankAccountDataWasUpdated(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ReimbursementHistory),
);
